/* eslint-disable class-methods-use-this, prefer-destructuring, no-undef, no-shadow, no-unused-vars */

class FloatingContent {
	constructor() {
		this.floatingContact = document.getElementsByClassName(
			"floating-contact-tool"
		)[0];
		if (this.floatingContact) {
			this.init();
		}
	}

	init() {
		const openButton = this.floatingContact.getElementsByClassName(
			"floating-contact-tool__open"
		)[0];
		const closeButton = this.floatingContact.getElementsByClassName(
			"floating-contact-tool__close"
		)[0];

		// Open button click
		openButton.addEventListener("click", this.openModal);

		// Close button click
		closeButton.addEventListener("click", this.closeModal);
	}

	openModal() {
		const modal = document.getElementsByClassName(
			"floating-contact-tool__modal"
		)[0];

		// Show modal
		modal.style.display = "initial";
		modal.style.opacity = 1;
	}

	closeModal() {
		const modal = document.getElementsByClassName(
			"floating-contact-tool__modal"
		)[0];

		// Hide modal
		modal.style.display = "none";
		modal.style.opacity = 0;
	}
}

export default FloatingContent;
